import React, { useEffect, useState } from "react";


import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType, HeadingLevel, AlignmentType } from "docx";
import { saveAs } from "file-saver";

import axios from "axios";
import TableComponent from "../../components/TableComponent";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/helpers";
import { Modal, Form } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import Select from "react-select";
const API_URL = process.env.REACT_APP_API_URL;


function Literature_report() {

    const [data_entry, setDataEntry] = useState([]);

    const { user } = useAuth();
    const [center, setCenter] = useState([]);
    const [center_list, setCenter_list] = useState([]);



    ////////////////////center list////////////////////////////
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;
        axios.get(`${API_URL}/get_center_list`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((res) => {
                setCenter_list(res.data.center_list || []);
            })
            .catch((err) => {
                console.error("Center list error:", err);
            });
    }, []);


    ////////////////literatire data//////////////////////////


    const [literature, setLiterature] = useState([]);
    const [literatures, setLiteratures] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${API_URL}/literature_types_list`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => setLiteratures(res.data.literatures || []))
            .catch((err) => console.error(err));
    }, []);

    const options = (literatures || []).map(item => ({
        value: String(item.literature_id),
        label: item.literature_name
    }));


    const optionsCenter = (center_list || []).map(item => ({
        value: String(item.centres_id),
        label: item.center_name
    }));


    useEffect(() => {
        console.log("user IDs:", user);
    }, [user]);


    ////////////////////////////
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token || !user) return; // Safety check

        const fetchData = async () => {
            try {
                const url = `${API_URL}/literature_avenue_data_id_wise`;

                const params = {};

                // Role: always pass as string
                params.role = user.role;

                // Center filter
                if (user.role === "3") {
                    // Admin: can select multiple centers
                    if (center.length > 0) {
                        params.center = center.join(",");
                    }
                    // if no center selected, fetch all centers
                } else {
                    // Non-admin: center is fixed to user's center
                    params.user_center = user.center; // user.center is a string
                }

                // Literature filter: multi-select
                if (literature.length > 0) {
                    params.literature = literature.join(",");
                }

                const res = await axios.get(url, {
                    headers: { Authorization: `Bearer ${token}` },
                    params,
                });

                setDataEntry(res.data.literatures || []);
            } catch (err) {
                console.error("Fetch Literature error:", err);
            }
        };

        fetchData();
    }, [literature, center, user]);


    ////////////////////////////////////////////////////////////////////////
    const generateWordFile = async () => {
        if (!data_entry || data_entry.length === 0) {
            alert("No data to export!");
            return;
        }

        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");

        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        // Document title
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Literature Report",
                                    bold: true,
                                    size: 48, // 24pt
                                    font: "Calibri",
                                }),
                            ],
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 400 },
                        }),

                        // Loop through literature items
                        ...data_entry.map((literatureItem) => {
                            const children = [];

                            // Literature Theme Heading
                            children.push(
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: literatureItem.literature_name,
                                            bold: true,
                                            size: 32, // 16pt
                                            font: "Calibri",
                                            color: "2F5496", // optional: a professional blue
                                        }),
                                    ],
                                    spacing: { after: 200 },
                                })
                            );

                            // Research Details
                            if (literatureItem.documents && literatureItem.documents.length > 0) {
                                literatureItem.documents.forEach((docItem, index) => {
                                    children.push(
                                        new Paragraph({
                                            children: [
                                                new TextRun({
                                                    text: `${index + 1}. ${docItem.research_details}`,
                                                    size: 24, // 12pt
                                                    font: "Times New Roman",
                                                }),
                                            ],
                                            spacing: { after: 120 },
                                        })
                                    );
                                });
                            } else {
                                children.push(
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: "No research details available",
                                                size: 24,
                                                font: "Times New Roman",
                                                italics: true,
                                                color: "808080", // grey for placeholder
                                            }),
                                        ],
                                        spacing: { after: 120 },
                                    })
                                );
                            }

                            // Optional: small separator line between themes
                            children.push(
                                new Paragraph({
                                    alignment: AlignmentType.LEFT,
                                    spacing: { after: 200 },
                                })
                            );

                            return children;
                        }).flat(),
                    ],
                },
            ],
        });

        const blob = await Packer.toBlob(doc);
        const fileName = `Literature_Report_${yyyy}-${mm}-${dd}.docx`;
        saveAs(blob, fileName);
    };

    ///////////////////////////////////////////////////////////////////////

    const columns = [
        { key: "index", label: "Sr.no", format: (_, __, index) => index + 1 },
        { key: "literature_name", label: "Literature Name", align: "left" },
        { key: "center_name/center_code", label: "Center Name /Code", format: (_, row) => `${row.center_name} / ${row.center_code}` },
        { key: "created_by", label: "Created By" },
        { key: "created_date", label: "Created Date", format: formatDate },

    ];
    return (

        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Literature Report</h3>


            </div>
            <div
                style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-end",
                    padding: "10px",
                    borderRadius: "8px",
                }}
            >
                {/* Literature */}
                <div style={{ flex: 1 }}>
                    <label className="fw-semibold">Literature Theme</label>

                    <Select
                        options={options}
                        isMulti
                        value={options.filter(opt => literature.includes(opt.value))}
                        onChange={(selected) => {
                            const values = selected ? selected.map(item => item.value) : [];
                            setLiterature(values);
                        }}
                        placeholder="Please select..." styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (base) => ({ ...base, zIndex: 9999 })
                        }}
                    />


                </div>

                {/* Center / Role-based UI */}
                {user?.role === "1" ? (
                    <div style={{ flex: 1 }}>
                        <label className="fw-semibold">Select Center</label>

                        {/* <Select
                            options={optionsCenter} isMulti

                            value={optionsCenter.filter(opt => center.includes(opt.value))}

                            onChange={(selected) => {
                                const values = selected ? selected.map(item => item.value) : [];
                                setCenter(values);
                            }} styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 })
                            }}
                            menuPortalTarget={document.body}
                            required
                        >

                        </Select> */}
                        <input
                            type="text"
                            className="form-control bg-light"
                            value={user?.center_name || ""}
                            readOnly
                        />
                    </div>
                ) : user?.role === "0" ? (
                    <div style={{ flex: 1 }}>
                        <label className="fw-semibold">Center</label>

                        <input
                            type="text"
                            className="form-control bg-light"
                            value={user?.center_name || ""}
                            readOnly
                        />
                    </div>
                ) : null}

                <Button size="sm" variant="info" className="me-2" onClick={generateWordFile}>
                    <i className="bi bi-file-earmark-word me-1"></i> Export
                </Button>
            </div>
            <TableComponent columns={columns} data={data_entry} rowsPerPage={10} maxHeight={400} headerClass="table-dark" />



        </Container>
    );
}
export default Literature_report;